var legalStatusAPI = require('../../api').LegalStatuses;

var angular = require('angular');

angular
	.module('app.directives')
	.directive('ngLegalStatusMatchingCriteria', function(){

		return {
			restrict: 'E',
			scope: {
				items: "=",
			},
			template: require('./template.pug'),
			replace: true,

			link: function(scope, element, attrs){

				scope.childClicked = childClicked;
				scope.parentClicked = parentClicked;

				scope.$watch('items', function(val){
					assignCheckedItems();
				})

				legalStatusAPI.GetLegalStatusesHierarchical().then(function(result){
					scope.statuses = result;

					//if we have values set the checked
					assignCheckedItems();
				});

				function assignCheckedItems(){
					if(scope.items !== undefined && scope.items != null && scope.items.length != null && scope.items.length > 0){
						if(scope.statuses !== undefined && scope.statuses != null && scope.statuses.length != null && scope.statuses.length > 0){
							ensureAllIdsAreInts(scope.items);

							scope.statuses.forEach(function(status){

								//if we have an item in scope.items then that status should be checked
								var entry = findItemFromScope(status);
								if(entry != null){
									status.checked = true;
								}

								if(status.children!= null && status.children.length > 0){
									status.children.forEach(function(child){
										
										//if we have an item in scope.items then that status should be checked
										var entry = findItemFromScope(child);
										if(entry != null){
											child.checked = true;
										}
									})

									status.checked = status.children.every(isChildSelected);						
								}
							})
						}
					}
				}

				function parentClicked(parent){

					//has no children so it a selectable root element
					if(parent.children == null || parent.children.length == 0){
						UpdateScopeItems(parent);
					}

					parent.children.forEach(function(child){
						child.checked = parent.checked;

						UpdateScopeItems(child);
					});
				}

				function childClicked(child, parent){
					parent.checked = parent.children.every(isChildSelected);						

					UpdateScopeItems(child);
				}

				function UpdateScopeItems(item){
					var entry = findItemFromScope(item);

					if(!item.checked && entry == null) return;

					//if it is not checked now but is already in the array we should remove it as only want to send up checked items
					if(!item.checked && entry != null){
						var index = scope.items.indexOf(entry);
						scope.items.splice(index, 1);
						return;
					}

					if(entry == null){
						entry = {
							id: item.id,
							parentId: item.parentId,
							name: item.name,
						}
						scope.items.push(entry);						
					}
						
					entry.checked = item.checked;
				}

				
				function isChildSelected(child, index, array){
					return child.checked;
				}

				function findItemFromScope(item){
					return scope.items.find(function(i){
						return i.id == item.id && i.parentId == item.parentId;
					});
				}

				function ensureAllIdsAreInts(items){
					items.forEach(function(item){						
						if(typeof item.id === 'string'){
							item.id = parseInt(item.id);
						}

					})

				}
			}
		}
	})
